module.exports = __webpack_public_path__ + "static/img/dzsb_selected_image.e2b608e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/dzsb_selected_image.png
// module id = /YCk
// module chunks = 44